import React, { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

/** Non-modal workspace that leaves the app navigation available. */
export default function WorkspacePanel({ open, onClose, ariaLabel, children, portal }) {
  const [left, setLeft] = useState(0);
  const panelRef = useRef(null);
  useLayoutEffect(() => {
    if (!open) return undefined;
    const previousFocus = document.activeElement;
    const panel = panelRef.current;
    let sidebar;
    const measure = () => {
      const nextSidebar = document.querySelector('[data-bun-sidebar]');
      if (sidebar !== nextSidebar) {
        if (sidebar) resizeObserver?.unobserve(sidebar);
        sidebar = nextSidebar;
        if (sidebar) resizeObserver?.observe(sidebar);
      }
      setLeft(sidebar?.getBoundingClientRect().right || 0);
    };
    const resizeObserver = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    const observer = new MutationObserver(measure);
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', measure);
    measure();
    panel.focus();
    return () => {
      observer.disconnect();
      resizeObserver?.disconnect();
      window.removeEventListener('resize', measure);
      if (panel.contains(document.activeElement) && previousFocus?.isConnected) previousFocus.focus();
    };
  }, [open]);

  if (!open) return null;
  return createPortal(<div className="bun"><section ref={panelRef} role="region" aria-label={ariaLabel} tabIndex={-1}
    className="fixed inset-y-0 right-0 z-30 flex min-w-0 flex-col overflow-clip bg-bun-surface font-instrument text-bun-text outline-none"
    style={{ left }} onKeyDown={event => {
      if (event.key === 'Escape' && !event.defaultPrevented && !event.target.closest('[role="dialog"]')) {
        event.stopPropagation();
        onClose(false);
      }
    }}>
    {children}
    {portal}
  </section></div>, document.body);
}
